import React, { useState } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import { Input } from '../../../../../components';

const StyledInput = styled(Input)`
  max-width: 25px;
  border: 1px solid var(--border-light);
  border-radius: 6px;
  padding: 10px 12px;
  box-shadow: 0px 2px 3px 0px var(--border-light) inset;
  text-align: center;
`;

const PickerInput = ({ max, setFrequency }) => {
  const [value, setValue] = useState('');

  const handleChange = (e) => {
    const newValue = e.target.value;
    if (/^\d*$/.test(newValue) && (newValue === '' || (newValue > 0 && newValue <= max))) {
      setValue(newValue);
      setFrequency(newValue);
    }
  };

  return <StyledInput placeholder='1' onChange={handleChange} value={value} type='text' />;
};

PickerInput.defaultProps = {
  max: 31
};

PickerInput.propTypes = {
  max: PropTypes.number,
  setFrequency: PropTypes.func.isRequired
};

export { PickerInput };
